// extracted by mini-css-extract-plugin
export default {"cls1":"BulkFollowSuggestion-cls1___3bcff388851581ce579","cls2":"BulkFollowSuggestion-cls2__f85d1be04f5ba5c8eac3 BulkFollowSuggestion-cls1___3bcff388851581ce579"};